import {
  call,
  put,
  takeEvery,
  all,
  fork,
  takeLatest,
  delay,
} from "redux-saga/effects";

import {
  GET_COMPANY,
  INVITE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  GET_COMPANY_LIST_TO_SWITCH,
  IS_COMPANY_LOADING,
  IS_COMPANY_LIST_TO_SWITCH_LOADING,
  IS_COMPANY_UPDATE_LOADING,
  COMPANY_INVITE_STATUS,
  COMPANY_DELETE_STATUS,
} from "./actionType";

import {
  companyApiResponseSuccess,
  companyApiResponseError,
  companyUpdateLoadingState,
  companyUpdateStatusState,
  companyResetError,
} from "./actions";

import getHxsmsTokenStorage from "../../helpers/getHxsmsTokenStorage";

import axios from "axios";
import i18n from "../../i18n";
import { translateApiError } from "../../helpers/translateApiError";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

const defaultPageParams = {
  rowsPerPage: 5,
  currentPage: 1,
  search: "",
  status: "",
};

function* getCompany({
  payload: { rowsPerPage, currentPage, search, status },
}) {
  try {
    yield put(companyUpdateLoadingState(IS_COMPANY_LOADING, true));
    yield put(companyResetError(GET_COMPANY));
    yield delay(500);

    const hxsmsToken = yield getHxsmsTokenStorage();

    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants`;
    let urlParams = {
      page: currentPage,
      take: rowsPerPage,
      order: "DESC",
    };

    if (search) urlParams = { ...urlParams, q: search };
    if (status !== "" && status !== "all")
      urlParams = { ...urlParams, status: status };

    const getCompanyApi = () =>
      axios.get(url, {
        params: urlParams,
        headers: {
          "hxsms-token": hxsmsToken || "",
        },
      });
    const response = yield call(getCompanyApi);

    yield put(companyApiResponseSuccess(GET_COMPANY, response));
  } catch (error) {
    // 403: api_helper already shows "no permission"; "try again later" would
    // be wrong, since retrying does not help.
    if (error?.status !== 403) {
      yield put(
        companyApiResponseError(
          GET_COMPANY,
          i18n.t("tenants.errors.getListFailed")
        )
      );
    }
  } finally {
    yield put(companyUpdateLoadingState(IS_COMPANY_LOADING, false));
  }
}

function* inviteCompany({ payload: { companyDetails } }) {
  try {
    yield put(companyUpdateStatusState(COMPANY_INVITE_STATUS, "loading"));
    yield put(companyResetError(COMPANY_INVITE_STATUS));
    yield delay(300);

    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants`;
    //const updateSmsProviderURL = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants/sms-provider`;

    const inviteCompanyApi = () => api.create(url, companyDetails);

    yield call(inviteCompanyApi);
    //const response = yield call(inviteCompanyApi);

    // const updateSmsProviderApi = () =>
    //   api.put(updateSmsProviderURL, {
    //     portalId: companyDetails?.portalId,
    //     companyId: response?.companyId,
    //     smsProvider: "teamplus",
    //     smsUID: companyDetails?.every8dUID,
    //     smsPWD: companyDetails?.every8dPassword,
    //   });

    // yield call(updateSmsProviderApi);

    yield put(companyUpdateStatusState(COMPANY_INVITE_STATUS, "success"));
    yield put({ type: GET_COMPANY, payload: defaultPageParams });
  } catch (error) {
    // Extract error message from response
    let errorMessage = i18n.t("tenants.errors.inviteFailed");

    if (
      error?.data?.errors &&
      Array.isArray(error.data.errors) &&
      error.data.errors.length > 0
    ) {
      // Use the first error from the errors array
      errorMessage = translateApiError(error.data.errors[0]);
    } else if (error?.data?.error) {
      errorMessage = translateApiError(error.data.error);
    } else if (error?.data?.message) {
      errorMessage = translateApiError(error.data);
    } else if (
      error === "Record already exist, Please contact your administrator"
    ) {
      errorMessage = translateApiError(error);
    }

    yield put(companyApiResponseError(INVITE_COMPANY, errorMessage));
    yield put(companyUpdateStatusState(COMPANY_INVITE_STATUS, "failed"));
  }
}

function* updateCompany({ payload: { id, companyDetails } }) {
  try {
    yield put(companyUpdateLoadingState(IS_COMPANY_UPDATE_LOADING, true));
    yield put(companyResetError(UPDATE_COMPANY));
    yield delay(300);

    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants/${id}`;
    const updateCompanyApi = () => api.update(url, companyDetails);
    const response = yield call(updateCompanyApi);

    yield put(companyApiResponseSuccess(UPDATE_COMPANY, response));
  } catch (error) {
    yield put(
      companyApiResponseError(
        UPDATE_COMPANY,
        i18n.t("tenants.errors.updateFailed")
      )
    );
  } finally {
    yield put(companyUpdateLoadingState(IS_COMPANY_UPDATE_LOADING, false));
  }
}

function* deleteCompany({ payload: { companyId } }) {
  try {
    yield put(companyUpdateStatusState(COMPANY_DELETE_STATUS, "loading"));
    yield put(companyResetError(DELETE_COMPANY));
    yield delay(300);

    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants/${companyId}`;
    const deleteCompanyApi = () => api.delete(url);
    yield call(deleteCompanyApi);

    yield put(companyUpdateStatusState(COMPANY_DELETE_STATUS, "success"));
    yield put({ type: GET_COMPANY, payload: defaultPageParams });
  } catch (error) {
    yield put(
      companyApiResponseError(
        DELETE_COMPANY,
        i18n.t("tenants.errors.deleteFailed")
      )
    );
    yield put(companyUpdateStatusState(COMPANY_DELETE_STATUS, "failed"));
  }
}

function* getCompanyListToSwitch({ payload: { rowsPerPage, currentPage } }) {
  try {
    yield put(
      companyUpdateLoadingState(IS_COMPANY_LIST_TO_SWITCH_LOADING, true)
    );
    yield put(companyResetError(GET_COMPANY_LIST_TO_SWITCH));
    yield delay(300);

    const hxsmsToken = yield getHxsmsTokenStorage();

    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/tenants`;
    let urlParams = {
      page: currentPage,
      take: rowsPerPage,
      order: "DESC",
    };

    const getCompanyApi = () =>
      axios.get(url, {
        params: urlParams,
        headers: {
          "hxsms-token": hxsmsToken || "",
        },
      });
    const response = yield call(getCompanyApi);

    yield put(companyApiResponseSuccess(GET_COMPANY_LIST_TO_SWITCH, response));
  } catch (error) {
    // 403: api_helper already shows "no permission" (see getCompany)
    if (error?.status !== 403) {
      yield put(
        companyApiResponseError(
          GET_COMPANY_LIST_TO_SWITCH,
          i18n.t("tenants.errors.getListFailed")
        )
      );
    }
  } finally {
    yield put(
      companyUpdateLoadingState(IS_COMPANY_LIST_TO_SWITCH_LOADING, false)
    );
  }
}

export function* watchGetCompany() {
  yield takeLatest(GET_COMPANY, getCompany);
}

export function* watchInviteCompany() {
  yield takeEvery(INVITE_COMPANY, inviteCompany);
}

export function* watchUpdateCompany() {
  yield takeLatest(UPDATE_COMPANY, updateCompany);
}

export function* watchDeleteCompany() {
  yield takeEvery(DELETE_COMPANY, deleteCompany);
}

export function* watchGetCompanyListToSwitch() {
  yield takeLatest(GET_COMPANY_LIST_TO_SWITCH, getCompanyListToSwitch);
}

function* CompanySaga() {
  yield all([
    fork(watchGetCompany),
    fork(watchInviteCompany),
    fork(watchUpdateCompany),
    fork(watchDeleteCompany),
    fork(watchGetCompanyListToSwitch),
  ]);
}

export default CompanySaga;
